import router from '../router';

export default function logUserOut(store) {
  if (store === undefined) {
    store = this.$store;
  }

  localStorage.removeItem('backgroundImage');
  localStorage.removeItem('specialDates');
  localStorage.removeItem("firebaseToken");
  store.commit('userData', null);
  store.commit('bedroomLanguage', {});
  router.push({name: 'welcome'});
}
